<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
	<label for="" class="title-history">
		<i class="fa fa-clipboard"></i>Prospecto de Venta
	</label>
	<input type="radio" [(ngModel)]="tab" [value]="0" id="list">
	<label for="list">
		<i class="fa fa-list"></i>Listado
	</label>
	<input type="radio" [(ngModel)]="tab" [value]="1" id="creation">
	<label for="creation">
		<i class="fa fa-circle-plus"></i>Creación
	</label>
</div>
<div class="card">
	<div class="card-body">
		<app-new-company-application [hidden]="tab != 1"></app-new-company-application>
		<app-list-applications [hidden]="tab != 0"></app-list-applications>
	</div>
</div>